// Centralised env access. Vite injects `import.meta.env.VITE_*` at build time.
// Mirrors the Angular `environment.ts` shape so feature code reads structured config.
interface EnvShape {
  appEnv: string;
  auth0: {
    domain: string;
    clientId: string;
    audience: string;
    scope: string;
    namespace: string;
    connection: string;
  };
  app: {
    dioolCoreUrl: string;
    dioolAppUrl: string;
    dioolBaseUrl: string;
    xBeVersion: string;
  };
}

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Missing required env var ${name}`);
  }
  return value;
}

export const env: EnvShape = {
  appEnv: import.meta.env.VITE_APP_ENV ?? 'development',
  auth0: {
    domain: required('VITE_AUTH0_DOMAIN', import.meta.env.VITE_AUTH0_DOMAIN),
    clientId: required('VITE_AUTH0_CLIENT_ID', import.meta.env.VITE_AUTH0_CLIENT_ID),
    audience: required('VITE_AUTH0_AUDIENCE', import.meta.env.VITE_AUTH0_AUDIENCE),
    scope: required('VITE_AUTH0_SCOPE', import.meta.env.VITE_AUTH0_SCOPE),
    namespace: import.meta.env.VITE_AUTH0_NAMESPACE ?? '',
    connection: import.meta.env.VITE_AUTH0_CONNECTION ?? '',
  },
  app: {
    dioolCoreUrl: required('VITE_DIOOL_CORE_URL', import.meta.env.VITE_DIOOL_CORE_URL),
    dioolAppUrl: import.meta.env.VITE_DIOOL_APP_URL ?? '',
    dioolBaseUrl: import.meta.env.VITE_DIOOL_BASE_URL ?? '',
    xBeVersion: required('VITE_XBE_VERSION', import.meta.env.VITE_XBE_VERSION),
  },
};
